export default "__VITE_ASSET__9b74f078__"